import $ from '../common/nano';
import BasicGallery from './BasicGallery';

$('.HalfMainGallery')
	.each((selector) => {
		new BasicGallery(selector);
	});